// Tiny typed wrappers around localStorage for the two pieces of state we
// persist between sessions: the guest token (resumes the same account) and the
// chosen display name. Every access is wrapped in try/catch because
// localStorage throws in private-mode / disabled-storage browsers.

const TOKEN_KEY = "mmo.token";
const NAME_KEY = "mmo.name";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage unavailable — fall back to in-session only */
  }
}

function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function getToken(): string | null {
  return read(TOKEN_KEY);
}

export function setToken(token: string): void {
  write(TOKEN_KEY, token);
}

export function clearToken(): void {
  remove(TOKEN_KEY);
}

export function getName(): string | null {
  return read(NAME_KEY);
}

export function setName(name: string): void {
  write(NAME_KEY, name);
}
